import axios from 'axios';
import authHeader from './auth-header';
import config from '../Config';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;


const getNalcoRateList = (page, pagesize, search, groupId, ordering) => {
  return axios.get(API_URL +'/api/'+ API_VERSION + '/nalco/', {headers: authHeader(), params: {
      page: page,
      pagesize: pagesize,
      search:search,
      die_group: groupId,
      ordering: ordering
  }});
};
const getNalcoRateQuotation = () => {
    return axios.get(API_URL +'/api/'+ API_VERSION + '/nalco/latest-nalco-rate/', {headers: authHeader()});
  };
const getNalcoRateArchiveList = (page, pagesize, search, ordering) => {
    return axios.get(API_URL +'/api/'+ API_VERSION + '/nalco/archive-list', {headers: authHeader(), params: {
        page: page,
        pagesize: pagesize,
        search: search,
        ordering: ordering
    }});
};

const getNalcoRateById = (id) => {
    return axios.get(`${API_URL}/api/${API_VERSION}/nalco/${id}`, {headers: authHeader()});
};
const addNalcoRate = (formData) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/nalco/`,
        formData, // Payload for the request body
        { headers: authHeader() }
    );
};
const updateNalcoRate = (id, formPayload) => {
    return axios.patch(
        `${API_URL}/api/${API_VERSION}/nalco/${id}/`, // Include the die group's ID in the URL
        formPayload, // Payload for the request body
        { headers: authHeader() }
    );
};
const deleteNalcoRate = (id) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/nalco/${id}/archive/`,
        {}, // Include the die group's ID in the URL
        { headers: authHeader() } // Authentication header
    );
};
const unArchiveNalcoRate = (id) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/nalco/${id}/unarchive/`, // Include the die group's ID in the URL
        {}, // Pass an empty object if no data needs to be sent
        { headers: authHeader() } // Authentication header
    );
};

const nalcoRateService = {
    getNalcoRateList,
    getNalcoRateQuotation,
    getNalcoRateArchiveList,
    getNalcoRateById,
    addNalcoRate,
    updateNalcoRate,
    deleteNalcoRate,
    unArchiveNalcoRate
};

export default nalcoRateService;
